import {combineReducers, createFeatureSelector} from '@ngrx/store';
import {neighborhoodsFeatureKey, neighborhoodsReducer, NeighborhoodsState} from './neighborhood/_store/neighborhood.reducer';
import {infoDeskFeatureKey, infoDeskReducer, InfoDeskState} from "./info-desk/_store/info-desk.reducer";
import {governingBodyFeatureKey, governingBodyReducer, GoverningBodyState} from "./governing-body/_store/governing-body.reducer";
import {tariffFeatureKey, tariffReducer, TariffState} from "./tariff/_store/tariff.reducer";
import {utilitiesOnlineFeatureKey, utilitiesOnlineReducer, UtilitiesOnlineState} from "./utilities-online/_store/utilities-online.reducer";
import {tenMeetingReducer, tenMeetingsFeatureKey, TenMeetingState} from "./meetings/_store/meetings.reducer";
import {tenantApartmentsFeatureKey, tenantApartmentsReducer, TenantApartmentsState} from "./apartments/_store/tenant-apartments.reducer";
import {tenFinancesFeatureKey, tenFinancesReducer, TenFinancesState} from "./finances/_store/finances.reducer";
import {customerServiceFeatureKey, customerServiceReducer, CustomerServiceState} from "./customer-service/_store/customer-service.reducer";
import {publicationsFeatureKey, publicationsReducer, PublicationsState} from "./publications/_store/publications.reducer";
import {documentsFeatureKey, documentsReducer, DocumentsState} from "./documents/_store/documents.reducer";
import {countersFeatureKey, countersReducer, CountersState} from './counters/_store/counters.reducer';

export const tenantFeatureKey = 'tenantCabinet';

export interface TenantCabinetState {
    [neighborhoodsFeatureKey]: NeighborhoodsState,
    [infoDeskFeatureKey]: InfoDeskState,
    [governingBodyFeatureKey]: GoverningBodyState,
    [tariffFeatureKey]: TariffState,
    [utilitiesOnlineFeatureKey]: UtilitiesOnlineState,
    [tenMeetingsFeatureKey]: TenMeetingState,
    [tenantApartmentsFeatureKey]: TenantApartmentsState,
    [tenFinancesFeatureKey]: TenFinancesState,
    [customerServiceFeatureKey]: CustomerServiceState,
    [documentsFeatureKey]: DocumentsState,
    [publicationsFeatureKey]: PublicationsState,
    [countersFeatureKey]: CountersState,
}

export const tenantCabinetReducers = combineReducers({
    [neighborhoodsFeatureKey]: neighborhoodsReducer,
    [infoDeskFeatureKey]: infoDeskReducer,
    [governingBodyFeatureKey]: governingBodyReducer,
    [tariffFeatureKey]: tariffReducer,
    [utilitiesOnlineFeatureKey]: utilitiesOnlineReducer,
    [tenMeetingsFeatureKey]: tenMeetingReducer,
    [tenantApartmentsFeatureKey]: tenantApartmentsReducer,
    [tenFinancesFeatureKey]: tenFinancesReducer,
    [customerServiceFeatureKey]: customerServiceReducer,
    [documentsFeatureKey]: documentsReducer,
    [publicationsFeatureKey]: publicationsReducer,
    [countersFeatureKey]: countersReducer,
});

export const getTenantState = createFeatureSelector<TenantCabinetState>(tenantFeatureKey);
